import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '43px'
  },

  icon: {
    width: '1rem',
    height: '1rem',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    marginRight: '0.5rem'
  },

  delete: {
    color: theme.palette.textAlt
  }
}))

export default useStyles
